"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@assets/js/src/windowGlobal");
require("es7-shim");
const Listing_1 = __importDefault(require("@react/web/Listing"));
const SubscriptionOfferDetail_1 = __importDefault(require("@react/web/SubscriptionOfferDetail"));
/**
 * @TODO Temporary "Failed to execute 'removeChild' on 'Node'" error identification
 * https://github.com/facebook/react/issues/11538#issuecomment-417504600
 */
if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    // @ts-ignore
    Node.prototype.removeChild = function (child) {
        if (child.parentNode !== this) {
            console.error('Cannot remove a child from a different parent:', child.data, this);
            return child;
        }
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        return originalRemoveChild.apply(this, arguments);
    };
    const originalInsertBefore = Node.prototype.insertBefore;
    // @ts-ignore
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            console.error('Cannot insert before a reference node from a different parent:', referenceNode, this);
            return newNode;
        }
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        return originalInsertBefore.apply(this, arguments);
    };
}
const subscriptionOfferDetailElement = document.getElementById('subscription-offer-detail');
const subscriptionOffersListElement = document.getElementById('subscription-offers-list');
if (subscriptionOfferDetailElement !== null) {
    (0, SubscriptionOfferDetail_1.default)(subscriptionOfferDetailElement);
}
if (subscriptionOffersListElement !== null) {
    (0, Listing_1.default)(subscriptionOffersListElement);
}
